/**
 * Type for the Zoom OAuth document stored in Firestore at:
 * teacherFeedback/auth/users/{uid}/oauth/zoom
 */

import {z} from 'zod';

// ============================================================================
// Document Schema
// ============================================================================

/**
 * Tokens returned by the Zoom OAuth token exchange endpoint.
 * `last_auth_timestamp` is not included here — it is a server-generated
 * timestamp injected automatically by the Firestore converter on write.
 */
export const ZoomOAuthDocumentSchema = z
  .object({
    access_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.number(),
    token_type: z.string(),
    scope: z.string(),
  })
  .loose();

export type ZoomOAuthDocument = z.infer<typeof ZoomOAuthDocumentSchema>;

// ============================================================================
// Paths
// ============================================================================

export function getZoomOAuthDocumentPath({uid}: {uid: string}): string {
  return `teacherFeedback/auth/users/${uid}/oauth/zoom`;
}
